import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { Col, Container, Row } from "reactstrap";
import styles from "./styles.module.scss";
import SimpleForm from "/components/SimpleForm";

export const BusinessSolutionsBody = ({
  customClass,
  image,
  content,
  backButtonLink,
  backButtonTitle,
  successPageUrl,
  footerCtaLink,
  footerCtaTitle,
  showFooterButton,
  showFooterPopupModal,
  footerPopupContent,
  footerPopupFormId,
}) => {
  Fancybox.bind("[data-src]", {
    // Your custom options
  });

  return (
    <section className={`${styles.root} ${customClass}`}>
      {backButtonLink && (
        <Container className="top-row">
          <a
            href={backButtonLink}
            className="text-nowrap arrow-left d-inline-flex align-items-center"
          >
            <strong>{backButtonTitle}</strong>
          </a>
        </Container>
      )}

      <Row className="mx-0 mt-5">
        <Col lg={4} className="pe-lg-5 ps-lg-0 mb-mb-5">
          <img
            src={
              image?.url
                ? image?.url
                : "/site-assets/placeholders/img-placeholder.jpg"
            }
            width={800}
            alt={image?.alt}
            className="card-img rounded-0 mb-4"
          />
        </Col>
        <Col lg={8} className="pe-lg-5">
          <div
            className="post-content"
            dangerouslySetInnerHTML={{ __html: content }}
          />
          {showFooterButton ? (
            showFooterPopupModal ? (
              <>
                <button
                  className="border-0 fancyBox primaryBtn no-arrow"
                  data-src="#footer-popup-modal"
                >
                  {footerCtaTitle}
                </button>
                <div className="dialog-content" id="footer-popup-modal">
                  <div>
                    {footerPopupContent && (
                      <>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: footerPopupContent,
                          }}
                        />
                        <hr />
                      </>
                    )}
                    <SimpleForm
                      formId={footerPopupFormId}
                      successPageUrl={successPageUrl}
                    />
                  </div>
                </div>
              </>
            ) : (
              <div className="mt-4">
                {footerCtaLink && (
                  <a href={footerCtaLink} className="primaryBtn no-arrow">
                    {footerCtaTitle}
                  </a>
                )}
              </div>
            )
          ) : null}
        </Col>
      </Row>
    </section>
  );
};

export default BusinessSolutionsBody;
